import { Renderer2 } from '@angular/core';
import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import {NgbDropdown, NgbTooltip} from "@ng-bootstrap/ng-bootstrap";

export interface SkyLayerColor {
  readonly label: string;
}

export interface SkyLayer {
  readonly id?: string;
  readonly type?: string;
  readonly label?: string;
  readonly baseUrl?: string;
  readonly selected?: boolean;
  readonly color?: SkyLayerColor;
  readonly hipsFrame?: string;
  readonly hipsOrder?: number;
  readonly format?: string;
  readonly active?: boolean;
}

export const skyLayersOptions: SkyLayer[] = [
  {
    type: 'Gamma-ray',
    id: 'FermiColor',
    label: 'FermiColor',
    baseUrl: 'https://alasky.u-strasbg.fr/Fermi/Color',
    selected: true,
    color: {label: 'native'},
    hipsOrder: 3,
    hipsFrame: 'equatorial',
    format: 'jpg'
  },
  {
    type: 'X-ray',
    id: 'SWIFT_BAT_FLUX',
    label: 'SWIFT_BAT_FLUX',
    baseUrl: 'https://alasky.u-strasbg.fr/JAXA/JAXA_P_SWIFT_BAT_FLUX',
    selected: true,
    color: {label: 'native'},
    hipsOrder: 6,
    hipsFrame: 'equatorial',
    format: 'png'
  },
  {
    type: 'X-ray',
    id: 'XMM-EPIC-RGB',
    label: 'XMM-EPIC-RGB',
    baseUrl: 'https://skies.esac.esa.int/XMM-Newton/EPIC-RGB',
    color: {label: 'native'},
    hipsOrder: 7,
    hipsFrame: 'equatorial',
    format: 'jpg'
  },
  {
    type: 'X-ray',
    id: 'ID1477875619',
    label: 'ID1477875619',
    baseUrl: 'https://darts.isas.jaxa.jp/pub/judo2/HiPS/maxi_ssc_sum',
    color: {label: 'native'},
    hipsOrder: 3,
    hipsFrame: 'equatorial',
    format: 'png'
  },
  {
    type: 'Ultraviolet',
    id: 'GALEX-GR6-Color',
    label: 'GALEX-GR6-Color',
    baseUrl: 'https://alasky.u-strasbg.fr/GALEX/GR6-03-2014/AIS-Color',
    selected: true,
    color: {label: 'native'},
    hipsOrder: 8,
    hipsFrame: 'equatorial',
    format: 'jpg'
  },
  {
    type: 'Optical',
    id: 'DSS colored',
    label: 'DSS colored',
    baseUrl: 'https://alasky.u-strasbg.fr/DSS/DSSColor',
    selected: true,
    color: {label: 'native'},
    hipsOrder: 9,
    hipsFrame: 'equatorial',
    format: 'jpg',
    active: true
  },
  {
    type: 'Optical',
    id: 'skymapper-color1',
    label: 'skymapper-color1',
    baseUrl: 'https://alasky.u-strasbg.fr/Skymapper/skymapper_color',
    color: {label: 'native'},
    hipsOrder: 9,
    hipsFrame: 'equatorial',
    format: 'png'
  },
  {
    type: 'Optical',
    id: 'DECaLS DR5 color',
    label: 'DECaLS DR5 color',
    baseUrl: 'https://alasky.u-strasbg.fr/DECaLS/DR5/color',
    color: {label: 'native'},
    hipsOrder: 11,
    hipsFrame: 'equatorial',
    format: 'jpg'
  },
  {
    type: 'Infrared',
    id: 'ULTRAVISTA color YJKs',
    label: 'ULTRAVISTA color YJKs',
    baseUrl: 'https://alasky.u-strasbg.fr/VISTA/UltraVista/ColorYJKs',
    color: {label: 'native'},
    hipsOrder: 12,
    hipsFrame: 'equatorial',
    format: 'jpg'
  },
  {
    type: 'Infrared',
    id: '2MASS-Color',
    label: '2MASS-Color',
    baseUrl: 'https://alasky.u-strasbg.fr/2MASS/Color',
    color: {label: 'native'},
    hipsOrder: 9,
    hipsFrame: 'equatorial',
    format: 'jpg'
  },
  {
    type: 'Infrared',
    id: 'AllWISE-color',
    label: 'AllWISE-color',
    baseUrl: 'https://alasky.u-strasbg.fr/AllWISE/RGB-W4-W2-W1',
    selected: true,
    color: {label: 'native'},
    hipsOrder: 8,
    hipsFrame: 'equatorial',
    format: 'jpg'
  },
  {
    type: 'Infrared',
    id: 'AKARI-FIS-Color',
    label: 'AKARI-FIS-Color',
    baseUrl: 'https://alasky.u-strasbg.fr/AKARI-FIS/ColorLSN60',
    color: {label: 'native'},
    hipsOrder: 5,
    hipsFrame: 'equatorial',
    format: 'jpg'
  },
  {
    type: 'Infrared',
    id: 'COHRS',
    label: 'COHRS',
    baseUrl: 'https://alasky.u-strasbg.fr/COHRS',
    color: {label: 'native'},
    hipsOrder: 7,
    hipsFrame: 'equatorial',
    format: 'jpg'
  },
  {
    type: 'Submillimetre',
    id: 'SPIRE-color',
    label: 'SPIRE-color',
    baseUrl: 'https://skies.esac.esa.int/Herschel/SPIRE-color',
    selected: true,
    color: {label: 'native'},
    hipsOrder: 7,
    hipsFrame: 'equatorial',
    format: 'jpg'
  },
  {
    type: 'Submillimetre',
    id: 'CDS_P_ACT_Planck_DR4_f90',
    label: 'ACT_Planck_DR5_f90',
    baseUrl: 'https://alasky.u-strasbg.fr/ACT/DR4/CDS_P_ACT_Planck_DR4_f90/',
    color: {label: 'native'},
    hipsOrder: 4,
    hipsFrame: 'equatorial',
    format: 'png'
  },
  {
    type: 'Submillimetre',
    id: 'CDS_P_ACT_Planck_DR4_f150',
    label: 'ACT_Planck_DR5_f150',
    baseUrl: 'https://alasky.u-strasbg.fr/ACT/DR4/CDS_P_ACT_Planck_DR4_f150/',
    color: {label: 'native'},
    hipsOrder: 4,
    hipsFrame: 'equatorial',
    format: 'png'
  },
  {
    type: 'Radio',
    id: 'Scuba2_450',
    label: 'Scuba2_450',
    baseUrl: 'https://alasky.u-strasbg.fr/SCUBA2/Scuba2_450',
    color: {label: 'native'},
    hipsOrder: 3,
    hipsFrame: 'equatorial',
    format: 'jpg'
  },
  {
    type: 'Radio',
    id: 'Scuba2_850',
    label: 'Scuba2_850',
    baseUrl: 'https://alasky.u-strasbg.fr/SCUBA2/Scuba2_850',
    color: {label: 'native'},
    hipsOrder: 9,
    hipsFrame: 'equatorial',
    format: 'jpg'
  },
  {
    type: 'Radio',
    id: 'NVSS intensity maps',
    label: 'NVSS intensity maps',
    baseUrl: 'https://alasky.u-strasbg.fr/NVSS/intensity',
    selected: true,
    color: {label: 'native'},
    hipsOrder: 5,
    hipsFrame: 'equatorial',
    format: 'jpg'
  },
  {
    type: 'Radio',
    id: 'SUMSS',
    label: 'SUMSS',
    baseUrl: 'https://alasky.u-strasbg.fr/SUMSS',
    color: {label: 'native'},
    hipsOrder: 6,
    hipsFrame: 'equatorial',
    format: 'png'
  },
  {
    type: 'Radio',
    id: 'VLSSr',
    label: 'VLSSr',
    baseUrl: 'https://alasky.u-strasbg.fr/VLSSr',
    color: {label: 'native'},
    hipsOrder: 5,
    hipsFrame: 'equatorial',
    format: 'png'
  }
];

export const skyLayersColorsOptions: SkyLayerColor[] = [
  {label: 'cubehelix'},
  {label: 'eosb'},
  {label: 'rainbow'},
  {label: 'grayscale'},
  {label: 'native'}
];

@Component({
  selector: 'asax-sky-view-aladin-sky-layers-options',
  templateUrl: './aladin-sky-layers-options.component.html',
  styleUrls: ['./aladin-sky-layers-options.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AladinSkyLayersOptionsComponent implements OnChanges {
  @ViewChild('dropdown', {static: true}) dropdown: NgbDropdown;
  @ViewChild('scrollableContainer') scrollableContainer: ElementRef | undefined;

  @Input() indexActiveSky: number;
  @Input() skyLayers: SkyLayer[];
  @Input() maxHeightForSkyOptions: number;
  @Input() maxWidthForSkyOptions: number;

  @Output() outSkyLayers = new EventEmitter<SkyLayer[]>();
  
  skyLayersOptions: SkyLayer[] = skyLayersOptions;
  skyLayersColors: SkyLayerColor[] = skyLayersColorsOptions;
  distinctSkyLayerTypes: Set<string>;

  constructor(private renderer: Renderer2) {
    
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.indexActiveSky && this.indexActiveSky !== undefined) {
      this.onIndexActiveSky();
    }

    if (changes.maxHeightForSkyOptions || changes.maxWidthForSkyOptions) {
      this.updateContainerSize();
    }
  }

  ngOnInit() {
    this.distinctSkyLayerTypes = this.getDistinctSkyLayersTypes();
  }

  ngAfterViewInit() {
    this.updateContainerSize();
  }

  activateSkyLayer(index: number): void {
    const skyLayers = this.skyLayers.map(skyLayer => ({...skyLayer, active: false}));
    skyLayers.splice(index, 1, {...skyLayers[index], active: true});

    this.emitSkyLayers(skyLayers);
  }

  getDistinctSkyLayersTypes(): Set<string> {
    return new Set(this.skyLayersOptions.map(image => image.type));
  }

  selectSkyLayerType(type: string, index: number): void {
    const isActive = this.skyLayers[index].active;
    const imageForSelectedType = this.skyLayersOptions.filter(image => image.type === type)[0];
    const newImageForSelectedType = {...imageForSelectedType, active: isActive};

    const skyLayers = [...this.skyLayers];
    skyLayers.splice(index, 1, newImageForSelectedType);

    this.emitSkyLayers(skyLayers);
  }

  getSkyLayersForType(type: string): SkyLayer[] {
    return this.skyLayersOptions.filter(image => image.type === type);
  }

  selectSkyLayerForType(skyLayer: SkyLayer, index: number): void {
    const active = this.skyLayers[index].active;
    const color = this.skyLayers[index].color;
    const newSkyLayer = {...skyLayer, active, color};

    const skyLayers = [...this.skyLayers];
    skyLayers.splice(index, 1, newSkyLayer);

    this.emitSkyLayers(skyLayers);
  }

  selectSkyLayerColor(color: SkyLayerColor, index: number): void {
    const newSkyLayer = {...this.skyLayers[index], color};

    const skyLayers = [...this.skyLayers];
    skyLayers.splice(index, 1, newSkyLayer);

    this.emitSkyLayers(skyLayers);
  }

  removeSkyLayer(index: number): void {
    const skyLayer = this.skyLayers[index];

    const skyLayers = [...this.skyLayers];
    skyLayers.splice(index, 1);

    if (skyLayer.active) {
      if (index >= skyLayers.length) {
        index--;
      }

      skyLayers[index] = {...skyLayers[index], active: true};
    }

    this.emitSkyLayers(skyLayers);
  }

  addSky(): void {
    const selectedSkies = [...this.skyLayers];
    selectedSkies.push({...this.skyLayersOptions[0], active: false, selected: false});

    this.emitSkyLayers(selectedSkies);

    // Scroll to the bottom
    setTimeout(() => {
      if (this.scrollableContainer) {
        const container = this.scrollableContainer.nativeElement;
        container.scrollTop = container.scrollHeight;
      }
    }, 0); // Delay to ensure DOM updates are rendered before scrolling

  }

  resetImages(): void {
    this.emitSkyLayers(skyLayersOptions.filter(i => i.selected).slice());
  }

  private emitSkyLayers(selectedSkies: SkyLayer[]): void {
    this.outSkyLayers.emit(selectedSkies);
  }

  private onIndexActiveSky(): void {
    const selectedImages = this.skyLayers.map(selectedImage => ({...selectedImage, active: false}));
    selectedImages.splice(this.indexActiveSky, 1, {...selectedImages[this.indexActiveSky], active: true});
    this.skyLayers = [...selectedImages];
  }

  showTooltip(tooltip: NgbTooltip) {
    tooltip.open();
    const tooltipElement: HTMLElement = document.querySelector('.tooltip');
    if (tooltipElement) {
      tooltipElement.style.pointerEvents = 'none';
    }
  }
  
  hideTooltip(tooltip: NgbTooltip) {
    tooltip.close();
  }
  updateContainerSize() {
    if (this.scrollableContainer) {
      this.renderer.setStyle(this.scrollableContainer.nativeElement, 'maxHeight', `${this.maxHeightForSkyOptions}px`);
      this.renderer.setStyle(this.scrollableContainer.nativeElement, 'maxWidth', `${this.maxWidthForSkyOptions}px`);
      this.renderer.setStyle(this.scrollableContainer.nativeElement, 'overflow', 'auto');
    }
  }
}
